import { init as giftCardBalanceInit } from './giftCardBalanceComponent';
import { init as privacyOptOutInit } from './privacyOptOutComponent';
import { init as contactUsInit } from './contactUsComponent';
import { init as loyaltyInit } from '../../../loyalty/js/components/loyaltyComponent';
import { init as genericEmailServiceInit } from '../../../core/js/components/genericEmailServiceComponent';
import { init as intlShippingInfoComponentInit } from '../../../help/js/components/intlShippingInfoComponent';
import {
    init as stylistPreferredLocationComponent
} from '../../../help/js/components/stylistPreferredLocationComponent';
import { init as emailUnsubscribeComponentInit } from '../../../help/js/components/emailUnsubscribeComponent';
import { init as emailSubscribeComponentInit } from '../../../help/js/components/emailSubscribeComponent';
import { init as requestCatalogComponentInit } from '../../../help/js/components/requestCatalogComponent';
import { init as productTrayInit } from '../../../core/js/components/productTrayComponent';
import { init as helpNavigationInit } from '@help/js/components/helpNavigationComponent';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import accordionSupport from '../../../core/js/uiSupport/accordion';
import { scrollToElement } from '../../../core/js/utils/scrollUtils';

import helpGenericEmailServiceTemplate from 'help-generic-email-service-template.j2';

export const emailSignUpComponentName = 'helpEmailSignUpComponent';

function afterConstruction() {
    accordionSupport(this, '.js-dropdown-container');
    accordionSupport(this, '.js-help-content');
}

function attachEvents() {
    $(document).on(
        this.scopedEvent('click'),
        this.scopedSelector('.js-join-rewards-link'),
        (e) => {
            e.preventDefault();
            scrollToElement($('.js-loyalty-page').parent());
        }
    );
}

/**
 * Bootstrap the component onto the page
 * @param {object} store The redux store
 * @param {object} overrides Component-level overrides config
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        children: [
            giftCardBalanceInit,
            privacyOptOutInit,
            contactUsInit,
            loyaltyInit,
            [genericEmailServiceInit, {
                template: helpGenericEmailServiceTemplate
            }],
            intlShippingInfoComponentInit,
            stylistPreferredLocationComponent,
            emailUnsubscribeComponentInit,
            emailSubscribeComponentInit,
            [productTrayInit, {
                feature: 'help'
            }],
            requestCatalogComponentInit,
            helpNavigationInit
        ],
        name: 'helpComponent',
        afterConstruction: afterConstruction,
        templateLocation: '.dom-help-content'
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
